var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDekstop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1366,
    height: 449,
    viewBox: "0 0 1366 449",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2300_106353",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1366,
    height: 449
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1366V401C1366 427.51 1344.51 449 1318 449H48C21.4903 449 0 427.51 0 401V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2300_106353)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_f_2300_106353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1256.68 277.873C894.901 639.655 794.752 1079 625.155 909.402C455.557 739.804 611.354 309.037 973.136 -52.7448C1334.92 -414.526 1765.68 -570.323 1935.28 -400.726C2104.88 -231.129 1618.46 -83.9086 1256.68 277.873Z",
    fill: "#896BFF"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter1_f_2300_106353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M484.789 -111.958C123.007 249.824 22.5734 688.883 -146.739 519.571C-316.052 350.258 -160.025 -80.279 201.757 -442.061C563.538 -803.842 994.075 -959.869 1163.39 -790.557C1332.7 -621.244 846.571 -473.739 484.789 -111.958Z",
    fill: "#52B6FF"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter2_f_2300_106353)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 297.653,
    cy: -759.639,
    r: 507.079,
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1279.22,
    y: 29.6121,
    width: 1187.72,
    height: 1187.72,
    rx: 593.858,
    transform: "rotate(90 1279.22 29.6121)",
    fill: "url(#paint0_linear_2300_106353)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1278.74,
    y: 30.0864,
    width: 1186.77,
    height: 1186.77,
    rx: 593.384,
    transform: "rotate(90 1278.74 30.0864)",
    stroke: "url(#paint1_linear_2300_106353)",
    strokeOpacity: 0.6,
    strokeWidth: 0.948611
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1013.44,
    y: 295.391,
    width: 656.157,
    height: 656.157,
    rx: 328.079,
    transform: "rotate(90 1013.44 295.391)",
    fill: "url(#paint2_linear_2300_106353)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1012.96,
    y: 295.866,
    width: 655.209,
    height: 655.209,
    rx: 327.604,
    transform: "rotate(90 1012.96 295.866)",
    stroke: "url(#paint3_linear_2300_106353)",
    strokeOpacity: 0.6,
    strokeWidth: 0.948611
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2300_106353",
    x: -107.45,
    y: -1133.33,
    width: 2741.56,
    height: 2744.3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 332.014,
    result: "effect1_foregroundBlur_2300_106353"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2300_106353",
    x: -879.125,
    y: -1522.94,
    width: 2741.25,
    height: 2743.99,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 332.014,
    result: "effect1_foregroundBlur_2300_106353"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_2300_106353",
    x: -588.87,
    y: -1646.16,
    width: 1773.05,
    height: 1773.05,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 189.722,
    result: "effect1_foregroundBlur_2300_106353"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2300_106353",
    x1: 1231.58,
    y1: 519.131,
    x2: 2097.57,
    y2: 972.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2300_106353",
    x1: 1254.1,
    y1: 430.418,
    x2: 1625.45,
    y2: 973.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2300_106353",
    x1: 987.12,
    y1: 565.828,
    x2: 1465.54,
    y2: 816.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2300_106353",
    x1: 999.56,
    y1: 516.818,
    x2: 1204.72,
    y2: 816.858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDekstop);
export default __webpack_public_path__ + "static/media/Dekstop.83f83d229ec8d7f381c7e0e64956c366.svg";
export { ForwardRef as ReactComponent };